import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Col, Modal } from "react-bootstrap";
import _ from "lodash";
import moment from "moment";

import Button from "../../../../components/common/button/Button";
import AdminTable from "../../../../components/common/table/AdminTable";
import AdvancedSearch from "./advancedSearch/Filters";
import { TableExportButton } from "../../../../components/common/table/TableExportButton";
import TableOptions from "../../../../components/common/table/TableOptions";
import Filters from "./Filters";
import styles from "./Invoices.scss";

import parseAdvancedSearch from "../../../../utils/parseAdvancedSearch";
import parseFilters from "../../../../utils/parseFilters";
import {
  encodeSearchParams,
  getFinalQueryString,
  getPageQueryString
} from "../../../../utils/parseQueries";
import parseSortData from "../../../../utils/parseSortData";
import { formatDateSmallWithoutTimezone } from "../../../../utils/dates";

const tableColumns = [
  {
    headerText: "DATE SUBMITTED",
    accessor: "created_at",
    sortable: true
  },
  {
    headerText: "FILENAME",
    accessor: "sort_filename",
    sortable: true
  },
  {
    headerText: "COMPANY NAME",
    accessor: "company_name",
    sortable: true
  },
  {
    headerText: "PROJECT TITLE",
    accessor: "sort_project_title",
    sortable: true
  },
  {
    headerText: "MEMBER NAME",
    accessor: "sort_member_name",
    sortable: true
  },
  {
    headerText: "AMOUNT",
    accessor: "amount",
    sortable: true
  },
  {
    headerText: "STATUS",
    accessor: "sort_status",
    sortable: true
  },
  {
    headerText: "ADDITIONAL INFORMATION",
    accessor: "additional_information",
    sortable: true
  }
];

class Invoices extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSearch: props.advancedSearch || [],
      filters: props.filters || [],
      currentPage: props.page || 1,
      showAdvancedSearch: false,
      showFilters: false,
      showModal: false,
      selectedInvoice: null
    };

    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleSubmitAdvancedSearch = this.handleSubmitAdvancedSearch.bind(
      this
    );
    this.handleSubmitFilters = this.handleSubmitFilters.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.openAdvancedSearch = this.openAdvancedSearch.bind(this);
    this.openFilters = this.openFilters.bind(this);
  }

  handleModalOpen(invoice) {
    this.setState({ showModal: true, selectedInvoice: invoice });
  }

  handleModalClose() {
    this.setState({ showModal: false, selectedInvoice: null });
  }

  handleSubmitAdvancedSearch(data) {
    const advancedSearch = parseAdvancedSearch(data.filters);
    const filters = parseFilters(this.state.filters);
    const finalQueryString = getFinalQueryString(filters + advancedSearch);

    this.props.getTable(finalQueryString);
    this.props.getCsvData(filters + advancedSearch);
    this.props.setPage({ table: "invoices", pageNumber: 1 });
    this.props.setSort({ table: "invoices", sortData: null });

    this.setState({ advancedSearch: data.filters, currentPage: 1 });

    this.props.history.push({
      ...this.props.location,
      search: encodeSearchParams(data.filters, this.state.filters)
    });
  }

  handleSubmitFilters(data) {
    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(data.filters);
    const finalQueryString = getFinalQueryString(filters + advancedSearch);

    this.props.getTable(finalQueryString);
    this.props.getCsvData(filters + advancedSearch);
    this.props.setPage({ table: "invoices", pageNumber: 1 });
    this.props.setSort({ table: "invoices", sortData: null });

    this.setState({ filters: data.filters, currentPage: 1 });

    this.props.history.push({
      ...this.props.location,
      search: encodeSearchParams(this.state.advancedSearch, data.filters)
    });
  }

  onPageChange(pageIndex) {
    window.scrollTo(0, 0);

    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(this.state.filters);
    const sort = parseSortData(this.props.sortData);
    const pageQuery = getPageQueryString(pageIndex);
    const finalQueryString = getFinalQueryString(
      pageQuery + filters + advancedSearch + sort
    );

    this.props.getTable(finalQueryString);
    this.props.setPage({ table: "invoices", pageNumber: pageIndex + 1 });

    this.setState({ currentPage: pageIndex + 1 });
  }

  onSortChange(sortData) {
    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(this.state.filters);
    const sort = parseSortData(sortData);
    const finalQueryString = getFinalQueryString(
      filters + advancedSearch + sort
    );

    this.props.getTable(finalQueryString);
    this.props.setPage({ table: "invoices", pageNumber: 1 });
    this.props.setSort({ table: "invoices", sortData });

    this.setState({ currentPage: 1 });
  }

  openAdvancedSearch() {
    this.setState({ showAdvancedSearch: true });
  }

  openFilters() {
    this.setState({ showFilters: true });
  }

  getInvoiceDownload(invoice) {
    return (
      _.get(invoice, "filename") && (
        <Link
          to="#"
          onClick={() => this.props.downloadInvoice(invoice.id)}
          data-download="false"
        >
          {invoice.filename}
        </Link>
      )
    );
  }

  getFilename(invoice) {
    return (
      invoice && (
        <Link to={`/admin/invoice/${invoice.id}/edit`}>{invoice.filename}</Link>
      )
    );
  }

  getProjectTitle(project) {
    return (
      project && (
        <Link to={`/admin/project/${project.id}/detail`}>{project.title}</Link>
      )
    );
  }

  getCompanyName(company) {
    return (
      company && (
        <Link to={`/admin/company/${company.id}/billing`}>{company.name}</Link>
      )
    );
  }

  getMemberName(member) {
    return (
      member && (
        <Link to={`/admin/member/approved/${member.id}/profile`}>
          {member.first_name} {member.last_name}
        </Link>
      )
    );
  }

  getInvoiceStatus(invoice) {
    return (
      <div>
        {_.get(invoice, "status.admin")}
        {/* <a
          className={styles.details}
          onClick={() => this.handleModalOpen(invoice)}
        >
          View Details
        </a> */}
      </div>
    );
  }

  getAdditionalInformation(invoice) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: _.get(invoice, "additional_information")
        }}
      />
    );
  }

  getTableData(target) {
    const invoices =
      target === "csv" ? this.props.invoices_csv : this.props.invoices;

    let data =
      invoices &&
      invoices.map(invoice => {
        const company =
          _.get(invoice, "project.employer.profile.company") || {};
        const project = _.get(invoice, "project") || {};
        const member = _.get(invoice, "user") || {};

        return {
          id: invoice.id,
          sort_filename: this.getInvoiceDownload(invoice),
          created_at: moment(_.get(invoice, "created_at")).format("M/DD/YYYY"),
          company_name: this.getCompanyName(company),
          sort_project_title: this.getProjectTitle(project),
          sort_member_name: this.getMemberName(member),
          sort_status: this.getInvoiceStatus(invoice),
          amount: _.get(invoice, "amount"),
          additional_information: this.getAdditionalInformation(invoice)
        };
      });

    return data;
  }

  renderAdditionalInformation(invoice) {
    return (
      <div>
        <p>
          <strong>Billing Period:</strong>{" "}
          {formatDateSmallWithoutTimezone(
            _.get(invoice, "billing_period_start")
          )}{" "}
          -{" "}
          {formatDateSmallWithoutTimezone(_.get(invoice, "billing_period_end"))}
        </p>
        <p>
          <strong>Quickbooks ID:</strong> {_.get(invoice, "quickbooks_id")}
        </p>
        <p>
          <strong>Additional information:</strong>{" "}
          <span
            dangerouslySetInnerHTML={{
              __html: _.get(invoice, "additional_information")
            }}
          />
        </p>
      </div>
    );
  }

  renderModal() {
    return (
      <Modal
        show={this.state.showModal}
        onHide={this.handleModalClose}
        dialogClassName={styles.modalContainer}
      >
        <Modal.Body className={styles.modalBody}>
          <div className={styles.title}>
            Billing Details for{" "}
            {_.get(this.state, "selectedInvoice.user.full_name")}
          </div>

          <div className={styles.dividerDouble} />

          <div className={styles.content}>
            {this.renderAdditionalInformation(this.state.selectedInvoice)}
          </div>

          <div className={styles.CTAContainer}>
            <Button
              isSecondary
              isSmall
              label="Edit details"
              onClick={() =>
                this.props.history.push(
                  `/admin/invoice/${this.state.selectedInvoice.id}/edit`
                )
              }
            />
            <Button isSmall label="Close" onClick={this.handleModalClose} />
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    return (
      <div>
        <AdvancedSearch
          show={this.state.showAdvancedSearch}
          onClose={() => this.setState({ showAdvancedSearch: false })}
          onSubmit={this.handleSubmitAdvancedSearch}
        />
        <Filters
          show={this.state.showFilters}
          onClose={() => this.setState({ showFilters: false })}
          onSubmit={this.handleSubmitFilters}
        />
        <TableOptions
          title="Invoices / All"
          paginationCount={this.props.paginationCount}
          onFilterClick={this.openFilters}
          filtersNumber={this.state.filters && this.state.filters.length}
          searchsNumber={
            this.state.advancedSearch && this.state.advancedSearch.length
          }
          tableColumns={tableColumns}
          onSearchClick={this.openAdvancedSearch}
        />
        <div className={styles.invoices}>
          <AdminTable
            page={this.state.currentPage - 1}
            tableData={this.getTableData()}
            tableColumns={tableColumns}
            loading={this.props.loading}
            selectable={false}
            numberOfPages={this.props.numberOfPages}
            onPageChange={this.onPageChange}
            noRowsText="No Invoices found"
            sortData={this.props.sortData}
            onSortChange={this.onSortChange}
            style={{
              height: "640px" // This will force the table body to overflow and scroll
            }}
          />
        </div>
        <Col
          lg={2}
          md={2}
          sm={2}
          style={{ textAlign: "center", paddingTop: "1.5em" }}
        >
          <TableExportButton
            tableColumns={tableColumns}
            tableData={this.getTableData("csv")}
          />
        </Col>

        {this.renderModal()}
      </div>
    );
  }
}

export default Invoices;



// WEBPACK FOOTER //
// ./src/routes/admin/invoices/components/Invoices.js